<template>
  <div>
     <section class="time-line-box">
          <div class="swiper-container text-center"> 
                <div class="swiper-wrapper">
                    <div class="swiper-slide" id="first_slide">
                      <div class="timestamp"><span class="date">{{estimatedDate(kit.woo_ordered_date,'woo_shipped_date','shipped','ordered_to_shipped_date')}}</span></div>
                      <div class="title"  v-bind:class = "[(kit.woo_ordered_date != null)?'status':'status_set']" id="first_item"><span>Ordered</span></div>
                    </div>
                    <div class="swiper-slide">
                      <div class="timestamp"><span class="date" id="woo_shipped_date">{{estimatedDate(kit.woo_shipped_date,'woo_delivered_date','shipped','shipped_to_delivered_date')}}</span></div>
                      <div class="title" v-bind:class = "[(kit.woo_shipped_date != null)?'status':'status_set']"><span>Shipped</span></div>
                    </div>
                    <div class="swiper-slide">
                      <div class="timestamp"><span class="date" id="woo_delivered_date">{{estimatedDate(kit.woo_delivered_date,'activated_at','shipped','delivered_to_activated_date')}}</span></div>   
                      <div class="title" v-bind:class = "[(kit.woo_delivered_date != null)?'status':'status_set']"><span>Delivered</span></div>
                    </div>
                    <div class="swiper-slide">
                      <div class="timestamp"><span class="date" id="activated_at">{{estimatedDate(kit.activated_at,'awaiting_at','activated','activated_to_intransit_date')}}</span></div>
                      <div class="title" v-bind:class = "[(kit.activated_at != null)?'status':'status_set']"><span>Activated</span></div>
                    </div>
                    <div class="swiper-slide">
                      <div class="timestamp"><span class="date"  id="awaiting_at">{{estimatedDate(kit.awaiting_at,'received_at','lab_awaiting','intransit_to_lab_received_date')}}</span></div>
                      <div class="title" v-bind:class = "[(kit.awaiting_at != null)?'status':'status_set']"><span>Submitted</span></div>
                    </div>
                    <div class="swiper-slide">
                      <div class="timestamp"><span class="date" id="received_at">{{estimatedDate(kit.received_at,'reported_at','lab_received','lab_received_to_complete_date')}}</span></div>
                      <div class="title" v-bind:class = "[(kit.received_at != null)?'status':'status_set']"><span>Received</span></div>
                    </div>
                     <div class="swiper-slide" id="last_slide">
                      <div class="timestamp"><span class="date" id="reported_at">{{estimatedDate(kit.reported_at,'','','')}}</span></div>
                      <div class="title" v-bind:class = "[(kit.reported_at != null)?'status':'status_set']" id="last_item"><span>Completed</span></div>
                    </div>
                </div>
                <div class="swiper-pagination"></div>
            </div>
       </section>
  </div>
</template>

<script>
import moment from "moment";
import { mapGetters,mapActions } from "vuex";
  export default {
    name: "Timelinenew",
    props:[
       'kit'
    ],
    data() {
     return {
       kitavg:{},
     }
    },
    computed:{
      ...mapGetters(['getTestKitAvg'])
    },
    methods: {
      ...mapActions(['testKitAvg']),
        estimatedDate(date,type,status,avg){
          if (date !== null) {
              if(this.kit.status == status && this.kit[type] == null && this.kitavg[avg] != null){
                    let newdate = moment(date);
                    let add = this.kitavg[avg].split(" ");
                    newdate = newdate.add(add[2],'hour');
                    newdate = newdate.add(add[0],'days').format('MM/DD/YYYY');
                    document.getElementById(type).innerHTML = "Est&nbsp;:&nbsp;"+ newdate;
                    return this.date(date);
              } else {
                  return this.date(date);
              }
          } else {
            return null
          }
      },
      date(localDate) {
        if (localDate !== null) {
          let date = new Date(localDate);
          return moment(date).format("MM/DD/YYYY");
        }
      }
    },
    async mounted(){
      await this.testKitAvg();
      this.kitavg = this.$store.getters.getTestKitAvg;
    },
  };
</script>
<style scoped lang="scss">
@import "../../../styles/colors";
.date{
  height: 20px;
}
.time-line-box {
  width: 100%;
}
.time-line-box  .title{
  font-family: TTNormsMedium, sans-serif;
}

.time-line-box .timeline {
  list-style-type: none;
  display: flex;
  padding: 0;
  text-align: center;
}

.time-line-box .timestamp {
  margin: auto;
  margin-bottom: 5px;
  padding: 0px 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-family: TTNormsLight, sans-serif;
}

.time-line-box .status {
  padding: 0px 10px;
  display: flex;
  justify-content: center;
  border-top: 3px solid  $green;
  position: relative;
  transition: all 200ms ease-in;
}
.time-line-box .status_set {
  padding: 0px 10px;
  display: flex;
  justify-content: center;
  border-top: 3px solid  #909090;
  position: relative;
  transition: all 200ms ease-in;
}
.time-line-box .status span {
  padding-top: 17px;
}
.time-line-box .status_set span {
  padding-top: 17px;
}
.time-line-box .status span:before {
  content: '';
  width: 12px;
  height: 12px;
  background-color: $green;
  border-radius: 12px;
  border: 2px solid  $green;
  position: absolute;
  left: 50%;
  top: 0%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  transition: all 200ms ease-in;
}
.time-line-box #first_item  span:before {
  left: 0% !important;
}
.time-line-box #first_slide {
   left: 60px;
}
#first_slide  span{
  padding-right: 118px;
}
.time-line-box #last_item  span:before {
  left: 100% !important;
}
.time-line-box #last_item {
  width: 110px;
}
.time-line-box #last_slide {
   left: -60px;
}
#last_slide  span{
  padding-left: 100px;
}
.time-line-box .status_set span::before {
  content: '';
  width: 12px;
  height: 12px;
  background-color: #909090;
  border-radius: 12px;
  border: 2px solid #909090;
  position: absolute;
  left: 50%;
  top: 0%;
  -webkit-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  transition: all 200ms ease-in;
}

.swiper-container {
  width: 100%; 
  margin: auto;
  overflow: hidden;
}
.swiper-wrapper{
  height: 70px;
  display: inline-flex;
  flex-direction: row;
  overflow:hidden;
  justify-content: center;
}
.swiper-container::-webkit-scrollbar-track{
   background:#a8a8a8b6;
}
.swiper-container::-webkit-scrollbar{
  height: 2px;
}
.swiper-container::-webkit-scrollbar-thumb{
   background: #4F4F4F !important;
}
.swiper-slide {
  text-align: center;
  font-size: 12px;
  width: 120px;
  height: 100%;
  position: relative;
}
</style>